import React, { useState } from 'react';
import { AvGroup } from 'availity-reactstrap-validation';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { Label } from 'reactstrap';
import PropTypes from 'prop-types';
import {
  getLocaleHierarchy,
  getLocalizedName,
} from '../../../../utility/util/util.service';
import { createFilter } from 'react-select';
import Creatable from 'react-select/creatable';
import { basePostQuery } from '../../../../utility/sb-api/sb-api.service';

const IngredientsField = ({
  object,
  setter,
  options,
  isDisabled,
  ...props
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const intl = useIntl();
  // concats all nameXX properties, to be able to search for a name in a different langugage
  // eg. you search for "Salz", it will return Salt, as Salz is german for Salt
  // result search string will be <nameDE>;<nameEN>;...
  const stringifyLocalized = (option) =>
    option?.type === 'FoodIngredient'
      ? getLocaleHierarchy(intl.locale).reduce(
          (searchString, locale) =>
            searchString + (option.data['name' + locale] || '') + ';',
          '',
        )
      : option?.label;

  const createIngredient = (data) =>
    basePostQuery(
      'admin/food-ingredients',
      data,
      null,
      null, // don't show success, it may confuse the user
      'createNewIngredientError', // only show error
    );

  return (
    <AvGroup
      data-testid="IngredientsField"
      className="react-select form-label-group"
    >
      <Creatable
        id={object?.id}
        isMulti={true}
        isDisabled={isDisabled || isSubmitting}
        isLoading={isSubmitting}
        delimiter=";"
        name="ingredients"
        noOptionsMessage={() =>
          intl.formatMessage({ id: 'noIngredientsAvailableToSelect' })
        }
        className={'react-select-container'}
        classNamePrefix={'react-select'}
        value={object?.ingredients}
        getOptionLabel={(option) =>
          option?.type === 'FoodIngredient'
            ? getLocalizedName(option, intl.locale)
            : option?.label
        }
        getOptionValue={(ingredient) => ingredient?.id}
        onChange={(values) =>
          setter({
            ...object,
            ingredients: values || [],
            ingredientIds: values?.map((ingredient) => ingredient.id) || [],
          })
        }
        onCreateOption={(name) => {
          setIsSubmitting(true);

          // create ingredient in users current locale
          const data = {
            ['name' + intl?.locale?.toUpperCase()]: name,
          };

          createIngredient(data)
            .then((newIngredient) => {
              setter({
                ...object,
                ingredients: [...object.ingredients, newIngredient],
                ingredientIds: [...object.ingredientIds, newIngredient.id],
              });

              setIsSubmitting(false);
            })
            .catch(() => setIsSubmitting(false));
        }}
        formatCreateLabel={(input) =>
          intl.formatMessage(
            { id: 'createNewIngredientInputLabel' },
            { input: input },
          )
        }
        filterOption={createFilter({ stringify: stringifyLocalized })}
        placeholder={intl.formatMessage({ id: 'selectIngredientsLabel' })}
        options={options}
        {...props}
      />
      <Label className="floating-label" for={object?.id}>
        <FormattedMessage id="ingredientsTitle" />
      </Label>
    </AvGroup>
  );
};

IngredientsField.propTypes = {
  object: PropTypes.object,
  setter: PropTypes.func,
  options: PropTypes.array,
  isDisabled: PropTypes.bool,
};

export default IngredientsField;
